import React from 'react';
import _, { isEqual } from 'lodash';
import { Box, FormHelperText, Typography, Stack } from '@mui/material';

import { RequiredField } from '../others/RequiredField';
import { useDynamicAction, useDynamicQuery, useDynamicFunction, useFullScreen, useDidMountEffect } from '../../services/hooks';
import { constructDependsOnParams, getDependsOnValue, handleShowOn, handleDynamicFunction } from '../../services/functions';
import { InfoField } from './InfoField';
import { DiscountSingleField } from './DiscountSingleField';

export const DiscountSpecialField = props => {
  const { field, formik, updateOptionsCallback, getFieldCallback, setLoadingCallback, handleDiscountActions, allowMoreThan2PromotionsSelected, initialParamsData } = props;
  const mediaWidth = useFullScreen() ? '300px' : '100%';
  const times = 5;
  const [selectedPromotionsCount, setSelectedPromotionsCount] = React.useState(0);
  const [selectedPromotions, setSelectedPromotions] = React.useState([null, null, null, null, null]);

  const action = useDynamicAction(
    field.depends_on,
    field.on_change,
    constructDependsOnParams(field.depends_on, field.name, formik.values
    ),
    formik.values[field.name]
  );
  const { query, data, loading } = useDynamicQuery(action);
  const dynamicFunction = useDynamicFunction(field.on_change_splitted ? field.on_change_splitted[0] : field.on_change);
  const [discountParameterValIsSet, setDiscountParameterValIsSet] = React.useState(false);
  const [firstPromotionSelected, setFirstPromotionSelected] = React.useState(false);

  React.useEffect(() => {
    updateOptionsCallback(data);
  }, [data]);

  React.useEffect(() => {
    setLoadingCallback(loading);
  }, [loading]);

  const handleChange = (val, idx) => {
    setFirstPromotionSelected(true);
    let clonePromotions = [...selectedPromotions];
    if (!val) {
      setSelectedPromotionsCount(0);
      clonePromotions = [null, null, null, null, null];
      setSelectedPromotions(clonePromotions);
    } else if (clonePromotions[idx]) {
      clonePromotions[idx] = val;
      setSelectedPromotions(clonePromotions);
    } else {
      setSelectedPromotionsCount(selectedPromotionsCount + 1);
      clonePromotions[idx] = val;
      setSelectedPromotions(clonePromotions);
    }
    formik.setFieldValue('discount', clonePromotions);
    let sections = null;
    if (!_.isNil(dynamicFunction)) {
      const res = handleDynamicFunction(dynamicFunction, formik, field, val);
      if (res.callback) {
        sections = props[res.callback](res.data, field.options.indexOf(val), val);
      }
    }
    handleDiscountActions(clonePromotions, sections);
  };

  useDidMountEffect(() => {
    if (formik.values.discount_code) {
      setSelectedPromotions(formik.values.discount);
      setSelectedPromotionsCount(formik.values.discount.length);
      formik.setFieldValue('discount_code', '');
    } else if (formik.values.discount !== selectedPromotions) {
      if (!firstPromotionSelected && isEqual(formik.values.discount, [null, null, null, null, null])) {
        return;
      }
      setSelectedPromotions(formik.values.discount);
      setSelectedPromotionsCount(0);
      if (isEqual(formik.values.discount, [null, null, null, null, null, null])) {
        // specjalny przypadek dla ZS
        field.dynamicOptions = [];
      }
      let sections = null;
      if (!_.isNil(dynamicFunction)) {
        const res = handleDynamicFunction(dynamicFunction, formik, field, null);
        if (res.callback) {
          sections = props[res.callback](res.data, field.options.indexOf(null), null);
        }
      }
      handleDiscountActions(formik.values.discount, sections);
    }
  }, [formik.values.discount]);

  React.useEffect(() => {
    if (initialParamsData.discount && field.dynamicOptions && field.dynamicOptions.length > 0 && !discountParameterValIsSet) {
      setFirstPromotionSelected(true);
      setSelectedPromotionsCount(1);
      setSelectedPromotions([initialParamsData.discount, null, null, null, null]);
      formik.setFieldValue('discount', [initialParamsData.discount, null, null, null, null]);
      setDiscountParameterValIsSet(true);
    }

  }, [field.dynamicOptions]);

  return (
    <Box style={{ display: field.hide ? 'none' : handleShowOn(
      field.show_on, formik.values,
      getFieldCallback(!_.isNil(field.show_on) ? field.show_on.trim().split(' ')[0].split('-')[0] : []))
      ? ''
      : 'none' }}>
      <Typography variant="subtitle1" >
        <b>{field.label}</b>
        <RequiredField required={field.required} isEmpty={_.isNumber(formik.values[field.name]) ? false : _.isEmpty(formik.values[field.name])} formikError={formik.touched[field.name] && Boolean(formik.errors[field.name])} />
      </Typography>
      <Box
        style={{ marginBottom: 15, maxWidth: mediaWidth }}
        fullWidth
        variant="outlined"
        error={formik.touched[field.name] && Boolean(formik.errors[field.name])}>
        {field.depends_on && _.isEmpty(formik.values[getDependsOnValue(field.depends_on)]) && _.isEmpty(field.dynamicOptions)
          ? <Typography color="error">{field.additional_info}</Typography>
          : (
            <Stack direction="column" justifyContent="center" alignItems="center" spacing={2} style={{ marginBottom: 15, maxWidth: mediaWidth }}>
              {[...Array(times)].map((e, key) => {
                if (key <= selectedPromotionsCount) {
                  return <DiscountSingleField
                    key={key}
                    options={field.dynamicOptions}
                    label={field.label}
                    i={key}
                    // name={field.name}
                    handleChangeCallback={handleChange}
                    prevId={ key == 0 ? null : selectedPromotions[key - 1]}
                    selectedPromotions={selectedPromotions}
                    value={selectedPromotions[key]}
                    selectedPromotionsCount={selectedPromotionsCount}
                    discount={formik.values.discount}
                    allowMoreThan2PromotionsSelected={allowMoreThan2PromotionsSelected}
                    hasBigFamilyCard={formik.values.has_big_family_card}
                  />;
                }

                return null;

              }
              )}
              {
                !_.isEmpty(field.infos)
                  ? _.map(field.infos, (info, key) => {
                    if (info.no_choices) {
                      return <Typography key={key} color={info.color}>
                        {!_.isNil(formik.values[field.name])
                          ? !_.isNil(field.dynamicOptions)
                            ? field.dynamicOptions.length > 0
                              ? null
                              : info.label
                            : info.label
                          : info.label}
                      </Typography>;
                    }
                  })
                  : null
              }
            </Stack>
          )
        }
        <FormHelperText>{formik.touched[field.name] && formik.errors[field.name]}</FormHelperText>
        {
          !_.isEmpty(field.infos)
            ? _.map(field.infos, (info, key) => {
              if (info.no_choices === false) {
                return <InfoField info={info} key={key} getFieldCallback={getFieldCallback} formikValues={formik.values} />;
              }
            })
            : null
        }
      </Box>
    </Box>

  );
};
